var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Grid, Menu, MenuItem, MenuList, Toolbar, Typography, useMediaQuery } from "@mui/material";
import MuiAppBar from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { assignedMenusByGroupURL, getUserProfileUrl, UserWiseBranches } from "../../api/url";
import { DotGridIcon, MenuButtonNew, Finance, Service, SparePart, Vehicle } from "../../assets/images";
import { DrawerWidth, LOCAL_STORAGE_KEYS, Module, isModuleConfig } from "../../constants";
import { setIsLeftMenuOpen, showLoader } from "../../redux/commonSlice";
import { getByIdAPI, getListAPI, setState } from "../../redux/crudSlice";
import { useAppDispatch } from "../../store/hooks";
import { getLocalStorageItem, setLocalStorageItem } from "../../utils/storageHelper";
import { MuiBox } from "../atoms/boxComponent";
import { MuiIconButton } from "../atoms/iconButtonComponent";
import { LogoComponent } from "../atoms/logoComponent";
import { MuiStack } from "../atoms/stackComponent";
import Loader from "../molecules/loader";
import { HeaderMenus } from "./headerMenus";
import { useSelector } from "react-redux";
import { systemColor } from "../../theme/systemColor";
import useAnalyticsEventTracker from "../../utils/useAnalyticsEventTracker";
import { setRbacStorage } from "../../builderPackage/rbac/rbac.entity";
var Img = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        // height: "24px",
        width: "24px",
        height: '24px'
    };
});
var MobileAppBar = styled(MuiAppBar, {
    shouldForwardProp: function (prop) { return prop !== 'open'; }
})(function (_ref2) {
    var theme = _ref2.theme, open = _ref2.open;
    return _objectSpread({}, {
        width: '100%',
        height: '64px',
        marginLeft: DrawerWidth,
        backgroundColor: Module === isModuleConfig.Bajaj ? systemColor.primary : '#4E555B',
        color: theme.palette.primary.dark,
        boxShadow: 'none'
    });
});
var arr = [{
        name: 'Service',
        src: Service
    }, {
        name: 'Vehicle',
        src: Vehicle
    }, {
        name: 'Spare parts',
        src: SparePart
    }, {
        name: 'Financials',
        src: Finance
    }];
export var Header = function (props) {
    var _modules, _modules2;
    var dispatch = useAppDispatch();
    var assignModuleData = getLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MODULEDATA);
    var selectedDesignation = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var handleMobileOpen = props.handleMobileOpen, desktopOpen = props.desktopOpen, handleDesktopOpen = props.handleDesktopOpen;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var _a = useState(null), dotgridIconAnchorEl = _a[0], setdotgridIconAnchorEl = _a[1];
    var openNewDocumentsMenu = Boolean(dotgridIconAnchorEl);
    var navigate = useNavigate();
    var commonState = useSelector(function (state) { return state.common; });
    var trackButtonClick = useAnalyticsEventTracker("Header");
    var safeAreaMargin = useSelector(function (state) {
        var _state$common;
        return (_state$common = state.common) === null || _state$common === void 0 ? void 0 : _state$common.safeAreaMargin;
    });
    var getUserByBranch = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'getBranchList',
                            url: UserWiseBranches
                        }))];
                case 1:
                    Result = _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error fetching branch types:", error_1);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleDotGridMenuClick = function (event) {
        trackButtonClick("ButtonClickEvent", "Drawer_Desktop_NineDot_Open", undefined);
        setdotgridIconAnchorEl(event.currentTarget);
    };
    var handleDotGridMenu = function () {
        trackButtonClick("ButtonClickEvent", "Drawer_Desktop_NineDot_Close", undefined);
        setdotgridIconAnchorEl(null);
    };
    var modules = function (data) {
        var modulesList = [];
        data === null || data === void 0 || data.map(function (itemValue) {
            var finalArr = arr === null || arr === void 0 ? void 0 : arr.find(function (item) { return item.name === itemValue.DisplayName; });
            if (finalArr) {
                modulesList.push(_objectSpread(_objectSpread({}, itemValue), {}, {
                    src: finalArr.src
                }));
            }
        });
        return modulesList;
    };
    var onModuleClickImage = function (event, item, i) { return __awaiter(void 0, void 0, void 0, function () {
        var _profileDetailsRespon, _moduleMenuListRespon, _moduleMenuListRespon2, _assignModuleData$i, profileDetailsResponse, resultedRole, body, moduleMenuListResponse, _moduleMenuListRespon3, _moduleMenuListRespon4, updatedList, MenuSequence, newList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClick("ButtonClickEvent", "Drawer_Desktop_Module_" + "".concat(item === null || item === void 0 ? void 0 : item.Name), undefined);
                    profileDetailsResponse = dispatch(getByIdAPI({
                        key: "",
                        url: getUserProfileUrl
                    }));
                    resultedRole = selectedDesignation && selectedDesignation.Name ? selectedDesignation : profileDetailsResponse === null || profileDetailsResponse === void 0 || (_profileDetailsRespon = profileDetailsResponse.payload) === null || _profileDetailsRespon === void 0 || (_profileDetailsRespon = _profileDetailsRespon.data) === null || _profileDetailsRespon === void 0 ? void 0 : _profileDetailsRespon.AssignedRole[0];
                    body = {
                        ModuleId: item === null || item === void 0 ? void 0 : item.ModuleId,
                        RoleId: resultedRole.RoleId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "assignMenusByGroupData",
                            url: assignedMenusByGroupURL,
                            request: body
                        }))];
                case 1:
                    moduleMenuListResponse = _a.sent();
                    if (moduleMenuListResponse !== null && moduleMenuListResponse !== void 0 && (_moduleMenuListRespon = moduleMenuListResponse.payload) !== null && _moduleMenuListRespon !== void 0 && _moduleMenuListRespon.value.success && moduleMenuListResponse !== null && moduleMenuListResponse !== void 0 && (_moduleMenuListRespon2 = moduleMenuListResponse.payload) !== null && _moduleMenuListRespon2 !== void 0 && (_moduleMenuListRespon2 = _moduleMenuListRespon2.value) !== null && _moduleMenuListRespon2 !== void 0 && _moduleMenuListRespon2.data) {
                        setRbacStorage(moduleMenuListResponse === null || moduleMenuListResponse === void 0 || (_moduleMenuListRespon3 = moduleMenuListResponse.payload) === null || _moduleMenuListRespon3 === void 0 || (_moduleMenuListRespon3 = _moduleMenuListRespon3.value) === null || _moduleMenuListRespon3 === void 0 ? void 0 : _moduleMenuListRespon3.data);
                        setdotgridIconAnchorEl(null);
                        updatedList = moduleMenuListResponse === null || moduleMenuListResponse === void 0 || (_moduleMenuListRespon4 = moduleMenuListResponse.payload) === null || _moduleMenuListRespon4 === void 0 || (_moduleMenuListRespon4 = _moduleMenuListRespon4.value) === null || _moduleMenuListRespon4 === void 0 || (_moduleMenuListRespon4 = _moduleMenuListRespon4.data) === null || _moduleMenuListRespon4 === void 0 ? void 0 : _moduleMenuListRespon4.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                            isSubMenuOpen: false
                        }); });
                        MenuSequence = updatedList === null || updatedList === void 0 ? void 0 : updatedList.sort(function (a, b) { return a.Sequence - b.Sequence; });
                        newList = MenuSequence.map(function (item) {
                            var subMenus = __spreadArray([], item.Menus, true);
                            var SubMenusSequence = subMenus === null || subMenus === void 0 ? void 0 : subMenus.sort(function (a, b) { return a.Sequence - b.Sequence; });
                            return _objectSpread(_objectSpread({}, item), {}, {
                                Menus: SubMenusSequence
                            });
                        });
                        dispatch(setState({
                            key: LOCAL_STORAGE_KEYS.ASSIGNED_MENUS,
                            value: newList
                        }));
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS, newList);
                    }
                    switch ((_assignModuleData$i = assignModuleData[i]) === null || _assignModuleData$i === void 0 ? void 0 : _assignModuleData$i.Name) {
                        case 'Service':
                            return [2 /*return*/, navigate("/dashboard")];
                        case 'Vehicle':
                            return [2 /*return*/, navigate("/vehicle")];
                        case "Financials":
                            return [2 /*return*/, navigate("/journalVoucher")];
                        case 'SpareParts':
                            return [2 /*return*/, navigate("/spareParts/dashboard")];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onLeftDrawerClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            trackButtonClick("ButtonClickEvent", "Drawer_Click_Open", undefined);
            dispatch(setIsLeftMenuOpen(!commonState.isMenuOpen));
            return [2 /*return*/];
        });
    }); };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !lgMode && /*#__PURE__*/ React.createElement(MobileAppBar //only for mobile view
    , {
        position: "fixed"
    }, safeAreaMargin !== null && safeAreaMargin !== void 0 && safeAreaMargin.top && (safeAreaMargin === null || safeAreaMargin === void 0 ? void 0 : safeAreaMargin.top) > 0 ? /*#__PURE__*/ React.createElement(Box, {
        height: safeAreaMargin === null || safeAreaMargin === void 0 ? void 0 : safeAreaMargin.top
    }) : null, /*#__PURE__*/ React.createElement(Toolbar, {
        sx: {
            justifyContent: 'space-between',
            px: 2,
            minHeight: 64,
            paddingTop: "12px",
            paddingBottom: "12px"
        }
    }, /*#__PURE__*/ React.createElement(MuiBox, {
        sx: {
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "leftDrawer",
        onClick: function () {
            onLeftDrawerClick();
        },
        size: "small"
    }, /*#__PURE__*/ React.createElement(Img, {
        src: MenuButtonNew,
        alt: "settingIcon",
        loading: "lazy"
    })), /*#__PURE__*/ React.createElement(LogoComponent, null)), /*#__PURE__*/ React.createElement(HeaderMenus, null)), /*#__PURE__*/ React.createElement(Loader, null)), lgMode && /*#__PURE__*/ React.createElement(MobileAppBar //only for desktop view
    , {
        position: "fixed",
        open: desktopOpen,
        sx: {
            zIndex: function (theme) { return theme.zIndex.drawer + 100; }
        }
    }, /*#__PURE__*/ React.createElement(Toolbar, {
        sx: {
            justifyContent: 'space-between',
            px: 2
        },
        disableGutters: true
    }, /*#__PURE__*/ React.createElement(MuiBox, {
        sx: {
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        color: "inherit",
        "aria-label": "open drawer",
        onClick: handleDotGridMenuClick,
        sx: {
            opacity: openNewDocumentsMenu ? 0.6 : 1
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: DotGridIcon,
        alt: "dot-grid-icon"
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        paddingLeft: 3
    }, /*#__PURE__*/ React.createElement(LogoComponent, null))), /*#__PURE__*/ React.createElement(HeaderMenus, null)), /*#__PURE__*/ React.createElement(Loader, null)), /*#__PURE__*/ React.createElement(Menu, {
        anchorEl: dotgridIconAnchorEl,
        id: "new-document-menu",
        open: openNewDocumentsMenu,
        onClose: handleDotGridMenu,
        sx: {
            overflow: 'visible',
            mt: 0.3,
            borderRadius: "8px"
            // top:'80px'
            // top:10
        },
        transformOrigin: {
            horizontal: 'left',
            vertical: 'top'
        },
        anchorOrigin: {
            horizontal: 'left',
            vertical: 'bottom'
        },
        MenuListProps: {
            'aria-labelledby': 'basic-button',
            sx: {
                padding: 0,
                whiteSpace: 'nowrap'
            }
        },
        slotProps: {
            paper: {
                sx: {
                    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                    borderRadius: '12px',
                    border: '1px solid #DEE4EB'
                    // height: '228px',
                }
            }
        },
        disableScrollLock: true
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: ((_modules = modules(assignModuleData)) === null || _modules === void 0 ? void 0 : _modules.length) > 1 ? '228px' : '120px',
        height: 'auto',
        padding: '20px',
        gap: '20px'
    }, /*#__PURE__*/ React.createElement(MenuList, {
        sx: {
            width: '100%',
            height: '100%',
            padding: 0,
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-around'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, (_modules2 = modules(assignModuleData)) === null || _modules2 === void 0 ? void 0 : _modules2.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6
        }, /*#__PURE__*/ React.createElement(MenuItem, {
            id: "new-document-".concat(index, "}"),
            dense: true,
            key: index,
            sx: {
                width: '84px',
                borderRadius: '8px',
                gap: '8px',
                height: '84px',
                justifyContent: 'center'
            },
            onClick: function (event) { return onModuleClickImage(event, item, index); }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            flexDirection: 'column',
            gap: "8px",
            justifyContent: 'space-between'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                justifyContent: 'center'
            }
        }, /*#__PURE__*/ React.createElement("img", {
            src: item === null || item === void 0 ? void 0 : item.src,
            alt: "dot-grid-icon",
            style: {}
        })), /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                justifyContent: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontWeight: 500,
                fontSize: '12px'
            }
        }, item === null || item === void 0 ? void 0 : item.DisplayName)))));
    }))))));
};
